import Icon from "@ant-design/icons";
import { ReactComponent as ClientSvg } from "./svg/client.svg";

const ClientIcon = (props) => <Icon component={ClientSvg} {...props} />;

export default ClientIcon;
